import { formatTanggal, formatRupiah } from "../../../Utils";
import "../../../App.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const Lapharian = (data, recordLeng, pageNumber, tglmulai, tglakhir) => {
  if (!data || data.length === 0) {
    alert("Tidak ada data untuk dicetak.");
    return;
  }

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const loadImageAsDataURL = (url) => {
  return fetch(url)
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        })
    );
};

const drawHeader = (logoDataUrl) => {
  const logoX = 10;
  const logoY = 8;
  const logoSize = 18;
  const textX = logoX + logoSize + 3;

  if (logoDataUrl) {
    doc.addImage(
      logoDataUrl,
      "PNG",
      logoX,
      logoY,
      logoSize,
      logoSize
    );
  }

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("KPRI SRI REJEKI", textX, 14);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text("Jl. Donomulyo No.164 Kab. Malang", textX, 19);

  const lineY = logoY + logoSize + 3;

  doc.setLineWidth(0.3);
  doc.line(8, lineY, pageWidth - 8, lineY);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Laporan Harian", pageWidth / 2, lineY + 8, {
    align: "center",
  });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text(
    `Tanggal: ${formatTanggal(tglmulai)} s/d ${formatTanggal(tglakhir)}`,
    pageWidth / 2,
    lineY + 14,
    {
      align: "center",
    }
  );

  return lineY + 18;
};
 

  const headers = [[
    "No.", "Tanggal", "No. Bukti", "uraian", "Perkiraan", "Debet", "Kredit"
  ]];


  let totalDebet = 0;
  let totalKredit = 0;

  let nomorUrut = 1;
  const nomorAwal = recordLeng * (pageNumber - 1);

  let previousNoBukti = null;

  const tableData = data.map((item) => {
    const isSameAsPrevious = item.jnobukti === previousNoBukti;
    previousNoBukti = item.jnobukti;

    const debet = parseFloat(item.debet) || 0;
    const kredit = parseFloat(item.kredit) || 0;

    if (!isSameAsPrevious) nomorUrut++;

    totalDebet += debet;
    totalKredit += kredit;

    return [
      { content: isSameAsPrevious ? "" : nomorAwal + nomorUrut - 1, styles: { halign: "right" } },
      { content: isSameAsPrevious ? "" : formatTanggal(item.jtanggal), styles: { halign: "center" } },
      { content: isSameAsPrevious ? "" : (item.jnobukti || "-"), styles: { halign: "center" } },
      { content: isSameAsPrevious ? "" : (item.uraian || "-"), styles: { halign: "left" } },
      { content: `${item.kdperk} - ${item.uraianperk}`, styles: { halign: "left" } },
      { content: formatRupiah(debet), styles: { halign: "right" } },
      { content: formatRupiah(kredit), styles: { halign: "right" } }
    ];
  });

  tableData.push([
    { content: "Total Keseluruhan:", colSpan: 5, styles: { halign: "center", fontStyle: "bold" } },
    { content: formatRupiah(totalDebet), styles: { halign: "right", fontStyle: "bold" } },
    { content: formatRupiah(totalKredit), styles: { halign: "right", fontStyle: "bold" } }
  ]);

 const renderTable = (startY) => {
  autoTable(doc, {
    head: headers,
    body: tableData,
    startY: startY,
    theme: "grid",
    styles: { fontSize: 8, cellPadding: 0.7 },
    headStyles: {
      halign: "center",
      valign: "middle",
      fontSize: 8,
      cellPadding: 2,
    },
    showHead: "everyPage",
    margin: { left: 9, right: 9 },
    tableWidth: "wrap",

    columnStyles: {
      0: { cellWidth: 10 },
      1: { cellWidth: 19 },
      2: { cellWidth: 27 },
      3: { cellWidth: 40 },
      4: { cellWidth: 46 },
      5: { cellWidth: 25 },
      6: { cellWidth: 25 },
    },
  });

  const pdfBlob = doc.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl, "_blank");
};
const customLogoUrl = "/koperasihitamputih.png";

loadImageAsDataURL(customLogoUrl)
  .then((logoDataUrl) => {
    console.log("Logo berhasil dimuat");
    const startY = drawHeader(logoDataUrl);
    renderTable(startY);
  })
  .catch((err) => {
    console.log("Logo gagal:", err);
    const startY = drawHeader();
    renderTable(startY);
  });
};

export default Lapharian;
